export { default } from './SimpleContentPage';
